import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ManagerFormValuesProps} from "../components/shopManagers/NewShopManagerModal";
import {BlackoutDateProps} from "../types/BlackoutPeriod";
import {ConditionsProps} from "../utils/segmentBuilder";

export interface UpdateSegmentRequest {
    domain: string;
    segmentId: number;
    title: string;
    description: string;
    conditions: ConditionsProps[];
}


export const updateSegment = async ({ domain, segmentId, title, description, conditions }: UpdateSegmentRequest): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `segment`,
        method: 'PUT',
        headers: {
            "Content-Type": "application/json",
        },
        params: {
            domain,
            segmentId,
            title,
            description,
            conditions
        },
        domain,
        isEncrypted: true,
    });
}